/** Pulse placeholder while round data loads. */
export function ScorecardSkeleton() {
  return (
    <div className="animate-pulse space-y-3 rounded-xl border border-line bg-paper p-3">
      <div className="flex justify-between">
        <div className="h-4 w-24 rounded bg-line" />
        <div className="h-4 w-16 rounded bg-line" />
      </div>
      <div className="grid grid-cols-9 gap-1">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="h-8 rounded bg-cream-warm" />
        ))}
      </div>
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex gap-2">
            <div className="h-9 w-9 shrink-0 rounded-full bg-line" />
            <div className="grid flex-1 grid-cols-9 gap-1">
              {Array.from({ length: 9 }).map((_, j) => (
                <div key={j} className="h-8 rounded bg-cream-warm" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PlayTabHomeSkeleton() {
  return (
    <div className="animate-pulse space-y-4">
      <div>
        <div className="mb-2 h-5 w-28 rounded bg-line" />
        <div className="mb-2 h-14 rounded-[14px] bg-paper shadow-bt" />
        <div className="h-14 rounded-[14px] bg-paper shadow-bt" />
      </div>
      <div>
        <div className="mb-2 h-5 w-32 rounded bg-line" />
        <div className="h-14 rounded-[14px] bg-paper shadow-bt" />
        <div className="mt-2 h-14 rounded-[14px] bg-paper shadow-bt" />
      </div>
    </div>
  );
}

export function ListSectionSkeleton({ rows = 2 }: { rows?: number }) {
  return (
    <div className="animate-pulse space-y-2">
      <div className="mb-2 h-5 w-32 rounded bg-line" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-14 rounded-[14px] bg-paper shadow-bt" />
      ))}
    </div>
  );
}
